"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var coreServicesBanner = function coreServicesBanner(providerServices) {
  if (!(0, _lodash.isArray)(providerServices)) {
    return providerServices.name;
  }
  var slimServices = (0, _lodash.reject)(providerServices, function (service) {
    return (0, _lodash.isEmpty)((0, _lodash.get)(service, 'relationships.parent', {}));
  }); // remove parent service types

  var sortedServicesNames = (0, _lodash.map)((0, _lodash.sortBy)(slimServices, 'attributes.name'), 'attributes.name'); // create an array of service names (strings)

  return sortedServicesNames.length > 1 ? "\n    ".concat(sortedServicesNames[0], " and ").concat(sortedServicesNames.length - 1, " more\n  ") : sortedServicesNames[0];
};
var _default = exports["default"] = coreServicesBanner;